import type { TextVariant } from '../Text'
import type { LabelSize } from './types'

export function getLabelVariant(labelSize?: LabelSize, fallback: TextVariant = 'small'): TextVariant {
	if (!labelSize || labelSize === 'body') return fallback
	return labelSize // h1-h6 map directly
}

// For Checkbox component which uses inline styles
export function getLabelFontSize(labelSize?: LabelSize): string {
	const sizeMap: Record<LabelSize, string> = {
		h1: '3.75rem', // text-6xl
		h2: '3rem', // text-5xl
		h3: '2.25rem', // text-4xl
		h4: '1.75rem', // text-[28px]
		h5: '1.5rem', // text-2xl
		h6: '1.25rem', // text-xl
		body: '1rem', // text-base
	}
	return sizeMap[labelSize ?? 'body']
}
